import { Component, inject, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StateService } from '@uirouter/core';
import { getSpaceAttributesFromSpace, SpacesService } from 'account-hybrid/common/components/spaces';
import { FtModalComponent } from '../../../common/components/modal/ft-modal.component';
import { FtModalChromeComponent } from '../../../common/components/modal/ft-modal-chrome.component';
import { FtSelectComponent } from '../../advocacy-group/touchpoint-sheets/ft-select.component';
import { AdvocatesApiService } from '../services/advocates-api.service';

/**
 * Native port of the v1 `people.details.cancelReservation` modal (details.html) + `vm.cancelReservation`
 * (details.controller.js). Confirms removal with a delete-reason, PUTs via AdvocatesApiService.delete,
 * then navigates to the people directory (v1 `goToDirectory`). Opened from the people-details body's
 * "Remove details" button.
 */
@Component({
    selector: 'ft-remove-guest-details-ng',
    imports: [TranslateModule, FtModalComponent, FtModalChromeComponent, FtSelectComponent],
    templateUrl: './remove-guest-details.component.html',
})
export class FtRemoveGuestDetailsComponent {
    readonly advocate = input<any>();
    readonly open = model(false);

    /** v1 vm.deleteReasons (order matters: [0]=cancelled, [1]=test). */
    protected readonly deleteReasons = [
        { value: 'Guest canceled reservation' },
        { value: 'Test user' },
        { value: 'Other' },
    ];
    protected reasonDeleted: any;

    private readonly api = inject(AdvocatesApiService);
    private readonly spaces = inject(SpacesService);
    private readonly stateService = inject(StateService);

    protected remove(): void {
        const advocate = this.advocate();
        const guestUUID = advocate?.guestUUID;
        const propertyUuid = this.spaces.getPropertyUuid()!;
        const reason: any = { DeleteReason: this.reasonDeleted };
        if (this.reasonDeleted === this.deleteReasons[0].value) reason.IsCancelled = true;
        else if (this.reasonDeleted === this.deleteReasons[1].value) reason.IsTest = true;
        this.api.delete(propertyUuid, guestUUID, reason).subscribe({
            next: () => {
                this.open.set(false);
                // v1 goToDirectory — leave the (now-removed) guest's detail sheet.
                this.stateService.go('people.directory', { ...getSpaceAttributesFromSpace(this.spaces.current) });
            },
        });
    }

    protected cancel(): void {
        this.reasonDeleted = undefined;
        this.open.set(false);
    }
}
